import React, { useContext } from 'react';
import { UserSessionContext } from 'src/context/UserSessionContext';
import { Navigate } from 'react-router-dom';

export const PageNotFound: React.FC = () => {
  const { user, setUser } = useContext(UserSessionContext);
  return (
    <>
      {typeof user.id === 'undefined' ? (
        <Navigate
          to='/login'
          replace
        />
      ) : (
        <>
          Hello {user.name}!! It looks like you stumbled to a non-existent page.
          You should go back to one of the valid pages!!!
        </>
      )}
    </>
  );
};

export default PageNotFound;
